module.exports = __webpack_public_path__ + "img/pic29.d9017831.png";